﻿import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/_core/composables/useAuthStore';
//import { useToasts } from '@/_core/composables/useToasts';

const Layout = () => import('./_shared/layout.vue')

const Index = () => import('./views/index/Index.vue')

const AnnouncementsIndex = () => import('./views/announcements/index.vue')
const AnnouncementsView = () => import('./views/announcements/view.vue')

const DocumentsIncorporation = () => import('./views/documents/incorporation.vue')
const DocumentsByLaws = () => import('./views/documents/byLaws.vue')
const DocumentsIndex = () => import('./views/documents/index.vue')
const DocumentsView = () => import('./views/documents/view.vue')

const ContactsIndex = () => import('./views/contacts/index.vue')
const ContactsView = () => import('./views/contacts/view.vue')

const ListingsIndex = () => import('./views/listings/index.vue')
const ListingsView = () => import('./views/listings/view.vue')

const StoresIndex = () => import('./views/stores/index.vue')
const StoresView = () => import('./views/stores/view.vue')

const baseUrl = '/public';// import.meta.env.BASE_URL;

const localRoutes = {
    name: 'Public',
    path: '/',
    component: Layout,
    props: false,
    meta: {
        //requiresAuth: true,
        //roles: ['Administrator']
    },
    children: [
        { path: '/', component: Index },

        {
            path: 'announcements',
            children: [
                //{ path: 'add', component: AnnouncementsAdd },
                //{ path: 'edit/:id', component: AnnouncementsEdit, props: true },
                { path: '', name: 'AnnouncementsIndex', component: AnnouncementsIndex },
                { path: 'view/:id', name: 'AnnouncementsView', component: AnnouncementsView, props: true },
            ]
        },
        {
            path: 'documents',
            children: [
                { path: '', name: 'DocumentsIndex', component: DocumentsIndex },
                { path: 'view/:id', name: 'DocumentsView', component: DocumentsView, props: true },

                //{ path: 'incorporation', name: 'DocumentsIncorporation', component: DocumentsIncorporation },
                //{ path: 'by-laws', name: 'DocumentsByLaws', component: DocumentsByLaws },
            ]
        },
        // {
        //     path: 'by-laws',
        //     children: [
        //         //{ path: 'add', component: AnnouncementsAdd },
        //         //{ path: 'edit/:id', component: AnnouncementsEdit, props: true },
        //         { path: '', name: 'ByLawsIndex', component: ByLawsIndex },
        //         //{ path: 'view/:id', name: 'AnnouncementsView', component: AnnouncementsView, props: true },
        //     ]
        // },

        {
            path: 'contacts',
            children: [
                { path: '', name: 'ContactsIndex', component: ContactsIndex },
                { path: 'view/:id', name: 'ContactsView', component: ContactsView, props: true },
            ]
        },

        {
            path: 'listings',
            children: [
                { path: '', name: 'ListingsIndex', component: ListingsIndex },
                { path: 'view/:id', name: 'ListingsView', component: ListingsView, props: true },
            ]
        },

        {
            path: 'stores',
            children: [
                { path: '', name: 'StoresIndex', component: StoresIndex },
                { path: 'view/:id', name: 'StoresView', component: StoresView, props: true },
            ]
        },
    ]
};

export const router = createRouter({
    history: createWebHistory(baseUrl),
    linkActiveClass: 'active',
    routes: [
        { ...localRoutes },
        // catch all redirect to home page
        { path: '/:pathMatch(.*)*', redirect: '/' }
    ]
});

router.beforeEach(async (to) => {
    //debugger;
    //eventBus.$emit('chat:close');

    var meta = to.meta;
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/accounts/login', '/accounts/logout', '/accounts/register'];
    const authRequired = meta.requiresAuth && !publicPages.includes(to.path);
    const authStore = useAuthStore();
    const user = authStore.user;

    //debugger
    if (authRequired && !user) {
        const loginUrl = new URL(`/accounts/login`, window.location.origin)
        loginUrl.searchParams.set('returnUrl', encodeURIComponent(to.href));
        window.location.href = loginUrl.toString();
        return false;
        //authStore.returnUrl = to.fullPath;
        //return {
        //    path: '/accounts/login/',
        //    query: { returnUrl: encodeURIComponent(to.fullPath) }
        //};
    }

    var roles = to.meta.roles;

    if (roles && !user.roles.some(e => roles.includes(e))) {
        const notAuthorizedUrl = new URL(`/accounts/not-authorized`, window.location.origin)
        //alert('You are not authorized to acccess this page.')
        //debugger;
        window.location.href = notAuthorizedUrl.toString();
        return false;
        //window.location.href = loginUrl.toString();

        //return false;
        //return false;
        //return {
        //    path: '/account/login/',
        //    query: { returnUrl: encodeURIComponent(to.fullPath) }
        //};
    }
});